import React, { FC, memo } from 'react';

import usePrefix from 'utils/usePrefix';

interface Props {
  average: number;
  count: number;
}

const AverageRating: FC<Props> = ({ average, count }) => {
  const t = usePrefix('Rating');

  return (
    <div>
      {t('average_rating')}:{' '}
      {count > 0 ? average.toFixed(1) : <span>{t('no_ratings')}</span>}
    </div>
  );
};

export default memo(AverageRating);
